/**
 * @property {Date} from
 * @property {Date} to
 */
export default class BillingPeriod {
  /**
   * @param {string} startDateTime
   * @param {string} endDateTime
   */
  constructor({ startDateTime, endDateTime }) {
    this.from = new Date(startDateTime);
    this.to = new Date(endDateTime);
  }
}
